<script setup lang="ts"></script>

<template>
  <div class="flex flex-col text-lavender text-base md:text-[20px] leading-6 tracking-[-0.6px] gap-4">
    <span class="text-purple-gray">
      Lingo Platform runs on Power Miles. Stake LINGO to earn Power Miles—the more you stake, the more you earn!
    </span>
    <span>
      New to crypto? <br>
      <span class="text-purple-gray text-sm leading-4 tracking-[-0.28px] font-semibold pt-2">
        Staking is like putting money into a savings account—except instead of earning interest, you get Power Miles to play & win prizes!
      </span>
    </span>
  </div>
</template>

<style scoped></style>
